module.exports = __webpack_public_path__ + "img/fb_equity_bank_lg_logo.7f316072.jpg";